{
  "id": "industries",
  "name": "Industries",
  "standard": "ISIC",
  "version": "Revision 5",
  "granularity": "All 463 four-digit industry classes",
  "license": "United Nations publisher terms; no explicit open license in source CSV",
  "licenseUrl": "https://www.un.org/en/about-us/terms-of-use",
  "attribution": "United Nations Statistics Division, International Standard Industrial Classification of All Economic Activities, Revision 5. Classification codes and titles only; whitespace normalized.",
  "sourceUrl": "https://unstats.un.org/unsd/classifications/Econ/Download/In%20Text/ISIC_Rev_5_english_structure.csv",
  "sourceSha256": "fc408f57bd3a4f33c35a4f384ec0010283dd72774892c8d48ae1330a8caeb57f",
  "retrievedAt": "2026-09-12",
  "options": [
    {
      "value": "6920",
      "label": "Accounting, bookkeeping and auditing activities; tax consultancy"
    },
    {
      "value": "9321",
      "label": "Activities of amusement parks and theme parks"
    },
    {
      "value": "3540",
      "label": "Activities of brokers and agents for electric power and natural gas"
    },
    {
      "value": "9411",
      "label": "Activities of business and employers membership organizations"
    },
    {
      "value": "8220",
      "label": "Activities of call centres"
    },
    {
      "value": "8291",
      "label": "Activities of collection agencies and credit bureaus"
    },
    {
      "value": "7810",
      "label": "Activities of employment placement agencies"
    },
    {
      "value": "9900",
      "label": "Activities of extraterritorial organizations and bodies"
    },
    {
      "value": "6422",
      "label": "Activities of financing conduits"
    },
    {
      "value": "7010",
      "label": "Activities of head offices"
    },
    {
      "value": "6421",
      "label": "Activities of holding companies"
    },
    {
      "value": "9700",
      "label": "Activities of households as employers of domestic personnel"
    },
    {
      "value": "6622",
      "label": "Activities of insurance agents and brokers"
    },
    {
      "value": "6431",
      "label": "Activities of money market funds"
    },
    {
      "value": "6432",
      "label": "Activities of non-money market investments funds"
    },
    {
      "value": "9499",
      "label": "Activities of other membership organizations n.e.c."
    },
    {
      "value": "9020",
      "label": "Activities of performing arts"
    },
    {
      "value": "9492",
      "label": "Activities of political organizations"
    },
    {
      "value": "9412",
      "label": "Activities of professional membership organizations"
    },
    {
      "value": "9491",
      "label": "Activities of religious organizations"
    },
    {
      "value": "9312",
      "label": "Activities of sports clubs"
    },
    {
      "value": "9420",
      "label": "Activities of trade unions"
    },
    {
      "value": "6433",
      "label": "Activities of trust, estate and agency accounts"
    },
    {
      "value": "6611",
      "label": "Administration of financial markets"
    },
    {
      "value": "7310",
      "label": "Advertising activities"
    },
    {
      "value": "7499",
      "label": "All other professional, scientific and technical activities n.e.c."
    },
    {
      "value": "7110",
      "label": "Architectural and engineering, and related technical consultancy activities"
    },
    {
      "value": "9112",
      "label": "Archive activities"
    },
    {
      "value": "9622",
      "label": "Beauty care and other beauty treatment activities"
    },
    {
      "value": "5630",
      "label": "Beverage serving activities"
    },
    {
      "value": "9141",
      "label": "Botanical and zoological garden activities"
    },
    {
      "value": "4330",
      "label": "Building completion and finishing"
    },
    {
      "value": "3012",
      "label": "Building of pleasure and sporting boats"
    },
    {
      "value": "3011",
      "label": "Building of ships and floating structures"
    },
    {
      "value": "7020",
      "label": "Business and other management consultancy activities"
    },
    {
      "value": "5530",
      "label": "Camping grounds, recreational vehicle parks and trailer parks"
    },
    {
      "value": "5224",
      "label": "Cargo handling"
    },
    {
      "value": "2431",
      "label": "Casting of iron and steel"
    },
    {
      "value": "2432",
      "label": "Casting of non-ferrous metals"
    },
    {
      "value": "6411",
      "label": "Central banking"
    },
    {
      "value": "3812",
      "label": "Collection of hazardous waste"
    },
    {
      "value": "3811",
      "label": "Collection of non-hazardous waste"
    },
    {
      "value": "8110",
      "label": "Combined facilities support activities"
    },
    {
      "value": "8430",
      "label": "Compulsory social security activities"
    },
    {
      "value": "6220",
      "label": "Computer consultancy and computer facilities management activities"
    },
    {
      "value": "6310",
      "label": "Computing infrastructure, data processing, hosting and related activities"
    },
    {
      "value": "9130",
      "label": "Conservation, restoration and other support activities for cultural heritage"
    },
    {
      "value": "4290",
      "label": "Construction of other civil engineering projects"
    },
    {
      "value": "4100",
      "label": "Construction of residential and non-residential buildings"
    },
    {
      "value": "4210",
      "label": "Construction of roads and railways"
    },
    {
      "value": "4220",
      "label": "Construction of utility projects"
    },
    {
      "value": "5320",
      "label": "Courier activities"
    },
    {
      "value": "8552",
      "label": "Cultural education"
    },
    {
      "value": "2396",
      "label": "Cutting, shaping and finishing of stone"
    },
    {
      "value": "9623",
      "label": "Day spa, sauna and steam bath activities"
    },
    {
      "value": "8422",
      "label": "Defence activities"
    },
    {
      "value": "4311",
      "label": "Demolition"
    },
    {
      "value": "6211",
      "label": "Development of video games, video game software, and video game software tools"
    },
    {
      "value": "1101",
      "label": "Distilling, rectifying and blending of spirits"
    },
    {
      "value": "8553",
      "label": "Driving school activities"
    },
    {
      "value": "3511",
      "label": "Electric power generation activities from non-renewable sources"
    },
    {
      "value": "3512",
      "label": "Electric power generation activities from renewable sources"
    },
    {
      "value": "3513",
      "label": "Electric power transmission and distribution activities"
    },
    {
      "value": "4321",
      "label": "Electrical installation"
    },
    {
      "value": "5621",
      "label": "Event catering activities"
    },
    {
      "value": "0610",
      "label": "Extraction of crude petroleum"
    },
    {
      "value": "0620",
      "label": "Extraction of natural gas"
    },
    {
      "value": "0892",
      "label": "Extraction of peat"
    },
    {
      "value": "0893",
      "label": "Extraction of salt"
    },
    {
      "value": "6493",
      "label": "Factoring activities"
    },
    {
      "value": "6491",
      "label": "Financial leasing activities"
    },
    {
      "value": "1313",
      "label": "Finishing of textiles"
    },
    {
      "value": "8421",
      "label": "Foreign affairs"
    },
    {
      "value": "2591",
      "label": "Forging, pressing, stamping and roll-forming of metal; powder metallurgy"
    },
    {
      "value": "5120",
      "label": "Freight air transport"
    },
    {
      "value": "4912",
      "label": "Freight rail transport"
    },
    {
      "value": "4923",
      "label": "Freight transport by road"
    },
    {
      "value": "0322",
      "label": "Freshwater aquaculture"
    },
    {
      "value": "0312",
      "label": "Freshwater fishing"
    },
    {
      "value": "6630",
      "label": "Fund management activities"
    },
    {
      "value": "9630",
      "label": "Funeral and related activities"
    },
    {
      "value": "9200",
      "label": "Gambling and betting activities"
    },
    {
      "value": "0230",
      "label": "Gathering of non-wood forest products"
    },
    {
      "value": "8121",
      "label": "General cleaning of buildings"
    },
    {
      "value": "8411",
      "label": "General public administration activities"
    },
    {
      "value": "8531",
      "label": "General secondary education"
    },
    {
      "value": "0127",
      "label": "Growing of beverage crops"
    },
    {
      "value": "0111",
      "label": "Growing of cereals (except rice), leguminous crops and oil seeds"
    },
    {
      "value": "0123",
      "label": "Growing of citrus fruits"
    },
    {
      "value": "0116",
      "label": "Growing of fibre crops"
    },
    {
      "value": "0121",
      "label": "Growing of grapes"
    },
    {
      "value": "0126",
      "label": "Growing of oleaginous fruits"
    },
    {
      "value": "0119",
      "label": "Growing of other non-perennial crops"
    },
    {
      "value": "0129",
      "label": "Growing of other perennial crops"
    },
    {
      "value": "0125",
      "label": "Growing of other tree and bush fruits and nuts"
    },
    {
      "value": "0124",
      "label": "Growing of pome fruits and stone fruits"
    },
    {
      "value": "0112",
      "label": "Growing of rice"
    },
    {
      "value": "0128",
      "label": "Growing of spices, aromatic, drug and pharmaceutical crops"
    },
    {
      "value": "0114",
      "label": "Growing of sugar cane"
    },
    {
      "value": "0115",
      "label": "Growing of tobacco"
    },
    {
      "value": "0122",
      "label": "Growing of tropical and subtropical fruits"
    },
    {
      "value": "0113",
      "label": "Growing of vegetables and melons, roots and tubers"
    },
    {
      "value": "9621",
      "label": "Hairdressing and barber activities"
    },
    {
      "value": "9122",
      "label": "Historical site and monument activities"
    },
    {
      "value": "8610",
      "label": "Hospital activities"
    },
    {
      "value": "5510",
      "label": "Hotels and similar accommodation activities"
    },
    {
      "value": "0170",
      "label": "Hunting, trapping and related service activities"
    },
    {
      "value": "5022",
      "label": "Inland freight water transport"
    },
    {
      "value": "5021",
      "label": "Inland passenger water transport"
    },
    {
      "value": "3320",
      "label": "Installation of industrial machinery and equipment"
    },
    {
      "value": "5540",
      "label": "Intermediation service activities for accommodation"
    },
    {
      "value": "8240",
      "label": "Intermediation service activities for business support activities n.e.c., except financial intermediation"
    },
    {
      "value": "8561",
      "label": "Intermediation service activities for courses and tutors"
    },
    {
      "value": "5640",
      "label": "Intermediation service activities for food and beverage services activities"
    },
    {
      "value": "5231",
      "label": "Intermediation service activities for freight transportation"
    },
    {
      "value": "8691",
      "label": "Intermediation service activities for medical, dental, and other human health services"
    },
    {
      "value": "5232",
      "label": "Intermediation service activities for passenger transportation"
    },
    {
      "value": "9640",
      "label": "Intermediation service activities for personal services"
    },
    {
      "value": "5330",
      "label": "Intermediation service activities for postal and courier activities"
    },
    {
      "value": "6821",
      "label": "Intermediation service activities for real estate"
    },
    {
      "value": "7751",
      "label": "Intermediation service activities for rental and leasing of cars, motorhomes and trailers"
    },
    {
      "value": "7752",
      "label": "Intermediation service activities for rental and leasing of other tangible goods and non-financial intangible assets"
    },
    {
      "value": "9540",
      "label": "Intermediation service activities for repair and maintenance of computers, personal and household goods, and motor vehicles and motorcycles"
    },
    {
      "value": "8791",
      "label": "Intermediation service activities for residential care activities"
    },
    {
      "value": "4790",
      "label": "Intermediation service activities for retail sale"
    },
    {
      "value": "4340",
      "label": "Intermediation service activities for specialized construction services"
    },
    {
      "value": "6492",
      "label": "International trade financing activities"
    },
    {
      "value": "8011",
      "label": "Investigation and private security activities"
    },
    {
      "value": "8130",
      "label": "Landscape service activities"
    },
    {
      "value": "7740",
      "label": "Leasing of intellectual property and similar products, except copyrighted works"
    },
    {
      "value": "6910",
      "label": "Legal activities"
    },
    {
      "value": "9111",
      "label": "Library activities"
    },
    {
      "value": "6511",
      "label": "Life insurance"
    },
    {
      "value": "9011",
      "label": "Literary creation and musical composition activities"
    },
    {
      "value": "0220",
      "label": "Logging"
    },
    {
      "value": "2821",
      "label": "Manufacture of agricultural and forestry machinery"
    },
    {
      "value": "3030",
      "label": "Manufacture of air and spacecraft and related machinery"
    },
    {
      "value": "2395",
      "label": "Manufacture of articles of concrete, cement and plaster"
    },
    {
      "value": "1420",
      "label": "Manufacture of articles of fur"
    },
    {
      "value": "1071",
      "label": "Manufacture of bakery products"
    },
    {
      "value": "2011",
      "label": "Manufacture of basic chemicals"
    },
    {
      "value": "2410",
      "label": "Manufacture of basic iron and steel"
    },
    {
      "value": "2420",
      "label": "Manufacture of basic precious and other non-ferrous metals"
    },
    {
      "value": "2720",
      "label": "Manufacture of batteries and accumulators"
    },
    {
      "value": "2814",
      "label": "Manufacture of bearings, gears, gearing and driving elements"
    },
    {
      "value": "1103",
      "label": "Manufacture of beer"
    },
    {
      "value": "3092",
      "label": "Manufacture of bicycles and invalid carriages"
    },
    {
      "value": "2920",
      "label": "Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi-trailers"
    },
    {
      "value": "1622",
      "label": "Manufacture of builders' carpentry and joinery"
    },
    {
      "value": "1393",
      "label": "Manufacture of carpets and rugs"
    },
    {
      "value": "2394",
      "label": "Manufacture of cement, lime and plaster"
    },
    {
      "value": "2392",
      "label": "Manufacture of clay building materials"
    },
    {
      "value": "1073",
      "label": "Manufacture of cocoa, chocolate and sugar confectionery"
    },
    {
      "value": "1910",
      "label": "Manufacture of coke oven products"
    },
    {
      "value": "2630",
      "label": "Manufacture of communication equipment"
    },
    {
      "value": "2620",
      "label": "Manufacture of computers and peripheral equipment"
    },
    {
      "value": "2640",
      "label": "Manufacture of consumer electronics"
    },
    {
      "value": "1394",
      "label": "Manufacture of cordage, rope, twine and netting"
    },
    {
      "value": "1702",
      "label": "Manufacture of corrugated paper and paperboard and of containers of paper and paperboard"
    },
    {
      "value": "2593",
      "label": "Manufacture of cutlery, hand tools and general hardware"
    },
    {
      "value": "1050",
      "label": "Manufacture of dairy products"
    },
    {
      "value": "2750",
      "label": "Manufacture of domestic appliances"
    },
    {
      "value": "2710",
      "label": "Manufacture of electric motors, generators, transformers and electricity distribution and control apparatus"
    },
    {
      "value": "2811",
      "label": "Manufacture of engines and turbines, except aircraft, vehicle and cycle engines"
    },
    {
      "value": "2012",
      "label": "Manufacture of fertilizers and nitrogen compounds"
    },
    {
      "value": "2731",
      "label": "Manufacture of fibre optic cables"
    },
    {
      "value": "2812",
      "label": "Manufacture of fluid power equipment"
    },
    {
      "value": "1520",
      "label": "Manufacture of footwear"
    },
    {
      "value": "3240",
      "label": "Manufacture of games and toys"
    },
    {
      "value": "3520",
      "label": "Manufacture of gas; distribution of gaseous fuels through mains"
    },
    {
      "value": "2310",
      "label": "Manufacture of glass and glass products"
    },
    {
      "value": "1061",
      "label": "Manufacture of grain mill products"
    },
    {
      "value": "3212",
      "label": "Manufacture of imitation jewellery and related articles"
    },
    {
      "value": "2660",
      "label": "Manufacture of irradiation, electromedical and electrotherapeutic equipment"
    },
    {
      "value": "3211",
      "label": "Manufacture of jewellery and related articles"
    },
    {
      "value": "1430",
      "label": "Manufacture of knitted and crocheted apparel"
    },
    {
      "value": "1391",
      "label": "Manufacture of knitted and crocheted fabrics"
    },
    {
      "value": "2816",
      "label": "Manufacture of lifting and handling equipment"
    },
    {
      "value": "2740",
      "label": "Manufacture of lighting equipment"
    },
    {
      "value": "1512",
      "label": "Manufacture of luggage, handbags and the like, saddlery and harness of any material"
    },
    {
      "value": "1074",
      "label": "Manufacture of macaroni, noodles, couscous and similar farinaceous products"
    },
    {
      "value": "2825",
      "label": "Manufacture of machinery for food, beverage and tobacco processing"
    },
    {
      "value": "2823",
      "label": "Manufacture of machinery for metallurgy"
    },
    {
      "value": "2824",
      "label": "Manufacture of machinery for mining, quarrying and construction"
    },
    {
      "value": "2826",
      "label": "Manufacture of machinery for textile, apparel and leather production"
    },
    {
      "value": "1392",
      "label": "Manufacture of made-up textile articles, except apparel"
    },
    {
      "value": "2680",
      "label": "Manufacture of magnetic and optical media"
    },
    {
      "value": "1104",
      "label": "Manufacture of malt"
    },
    {
      "value": "2030",
      "label": "Manufacture of man-made fibres"
    },
    {
      "value": "2651",
      "label": "Manufacture of measuring, testing, navigating and control equipment"
    },
    {
      "value": "3250",
      "label": "Manufacture of medical and dental instruments and supplies"
    },
    {
      "value": "2822",
      "label": "Manufacture of metal-forming machinery and machine tools"
    },
    {
      "value": "3040",
      "label": "Manufacture of military fighting vehicles"
    },
    {
      "value": "2910",
      "label": "Manufacture of motor vehicles"
    },
    {
      "value": "3091",
      "label": "Manufacture of motorcycles"
    },
    {
      "value": "3220",
      "label": "Manufacture of musical instruments"
    },
    {
      "value": "2817",
      "label": "Manufacture of office machinery and equipment (except computers and peripheral equipment)"
    },
    {
      "value": "2670",
      "label": "Manufacture of optical instruments and photographic equipment"
    },
    {
      "value": "1709",
      "label": "Manufacture of other articles of paper and paperboard"
    },
    {
      "value": "2029",
      "label": "Manufacture of other chemical products n.e.c."
    },
    {
      "value": "2790",
      "label": "Manufacture of other electrical equipment"
    },
    {
      "value": "2732",
      "label": "Manufacture of other electronic and electric wires and cables"
    },
    {
      "value": "2619",
      "label": "Manufacture of other electronic components and boards"
    },
    {
      "value": "2599",
      "label": "Manufacture of other fabricated metal products n.e.c."
    },
    {
      "value": "1079",
      "label": "Manufacture of other food products n.e.c."
    },
    {
      "value": "3102",
      "label": "Manufacture of other furniture"
    },
    {
      "value": "2819",
      "label": "Manufacture of other general-purpose machinery"
    },
    {
      "value": "2399",
      "label": "Manufacture of other non-metallic mineral products n.e.c."
    },
    {
      "value": "2393",
      "label": "Manufacture of other porcelain and ceramic products"
    },
    {
      "value": "1629",
      "label": "Manufacture of other products of wood; manufacture of articles of cork, straw and plaiting materials"
    },
    {
      "value": "2813",
      "label": "Manufacture of other pumps, compressors, taps and valves"
    },
    {
      "value": "2219",
      "label": "Manufacture of other rubber products"
    },
    {
      "value": "2829",
      "label": "Manufacture of other special-purpose machinery"
    },
    {
      "value": "1399",
      "label": "Manufacture of other textiles n.e.c."
    },
    {
      "value": "3099",
      "label": "Manufacture of other transport equipment n.e.c."
    },
    {
      "value": "2815",
      "label": "Manufacture of ovens, furnaces and permanent household heating equipment"
    },
    {
      "value": "2022",
      "label": "Manufacture of paints, varnishes and similar coatings, printing ink and mastics"
    },
    {
      "value": "2930",
      "label": "Manufacture of parts and accessories for motor vehicles"
    },
    {
      "value": "2021",
      "label": "Manufacture of pesticides and other agrochemical products"
    },
    {
      "value": "2100",
      "label": "Manufacture of pharmaceuticals, medicinal chemical and botanical products"
    },
    {
      "value": "2013",
      "label": "Manufacture of plastics and synthetic rubber in primary forms"
    },
    {
      "value": "2220",
      "label": "Manufacture of plastics products"
    },
    {
      "value": "2818",
      "label": "Manufacture of power-driven hand tools"
    },
    {
      "value": "1080",
      "label": "Manufacture of prepared animal feeds"
    },
    {
      "value": "1075",
      "label": "Manufacture of prepared meals and dishes"
    },
    {
      "value": "1701",
      "label": "Manufacture of pulp, paper and paperboard"
    },
    {
      "value": "3020",
      "label": "Manufacture of railway locomotives and rolling stock"
    },
    {
      "value": "1920",
      "label": "Manufacture of refined petroleum products; manufacture of fossil fuel products"
    },
    {
      "value": "2391",
      "label": "Manufacture of refractory products"
    },
    {
      "value": "2211",
      "label": "Manufacture of rubber tyres and tubes; retreading and rebuilding of rubber tyres"
    },
    {
      "value": "2023",
      "label": "Manufacture of soap and detergents, cleaning and polishing preparations, perfumes and toilet preparations"
    },
    {
      "value": "1105",
      "label": "Manufacture of soft drinks; production of mineral waters and other bottled waters"
    },
    {
      "value": "2611",
      "label": "Manufacture of solar cells, solar panels and photovoltaic inverters"
    },
    {
      "value": "3230",
      "label": "Manufacture of sports goods"
    },
    {
      "value": "1062",
      "label": "Manufacture of starches and starch products"
    },
    {
      "value": "2513",
      "label": "Manufacture of steam generators, except central heating hot water boilers"
    },
    {
      "value": "2511",
      "label": "Manufacture of structural metal products"
    },
    {
      "value": "1072",
      "label": "Manufacture of sugar"
    },
    {
      "value": "2512",
      "label": "Manufacture of tanks, reservoirs and containers of metal"
    },
    {
      "value": "1200",
      "label": "Manufacture of tobacco products"
    },
    {
      "value": "1040",
      "label": "Manufacture of vegetable and animal oils and fats"
    },
    {
      "value": "1621",
      "label": "Manufacture of veneer sheets and wood-based panels"
    },
    {
      "value": "2652",
      "label": "Manufacture of watches and clocks"
    },
    {
      "value": "2520",
      "label": "Manufacture of weapons and ammunition"
    },
    {
      "value": "1410",
      "label": "Manufacture of wearing apparel, except fur apparel"
    },
    {
      "value": "1102",
      "label": "Manufacture of wines"
    },
    {
      "value": "2733",
      "label": "Manufacture of wiring devices"
    },
    {
      "value": "1623",
      "label": "Manufacture of wooden containers"
    },
    {
      "value": "3101",
      "label": "Manufacture of wooden furniture"
    },
    {
      "value": "0321",
      "label": "Marine aquaculture"
    },
    {
      "value": "0311",
      "label": "Marine fishing"
    },
    {
      "value": "7320",
      "label": "Market research and public opinion polling activities"
    },
    {
      "value": "3830",
      "label": "Materials and other waste recovery"
    },
    {
      "value": "8620",
      "label": "Medical and dental practice activities"
    },
    {
      "value": "0891",
      "label": "Mining of chemical and fertilizer minerals"
    },
    {
      "value": "0510",
      "label": "Mining of hard coal"
    },
    {
      "value": "0710",
      "label": "Mining of iron ores"
    },
    {
      "value": "0520",
      "label": "Mining of lignite"
    },
    {
      "value": "0729",
      "label": "Mining of other non-ferrous metal ores"
    },
    {
      "value": "0721",
      "label": "Mining of uranium and thorium ores"
    },
    {
      "value": "0150",
      "label": "Mixed farming"
    },
    {
      "value": "5914",
      "label": "Motion picture projection activities"
    },
    {
      "value": "5913",
      "label": "Motion picture, video and television programme distribution activities"
    },
    {
      "value": "5912",
      "label": "Motion picture, video and television programme post-production activities"
    },
    {
      "value": "5911",
      "label": "Motion picture, video and television programme production activities"
    },
    {
      "value": "9121",
      "label": "Museum and collection activities"
    },
    {
      "value": "9142",
      "label": "Nature reserve activities"
    },
    {
      "value": "6031",
      "label": "News agency activities"
    },
    {
      "value": "6512",
      "label": "Non-life insurance"
    },
    {
      "value": "4711",
      "label": "Non-specialized retail sale with food, beverages or tobacco predominating"
    },
    {
      "value": "4690",
      "label": "Non-specialized wholesale trade"
    },
    {
      "value": "8210",
      "label": "Office administrative and support activities"
    },
    {
      "value": "9031",
      "label": "Operation of arts facilities and sites"
    },
    {
      "value": "9311",
      "label": "Operation of sports facilities"
    },
    {
      "value": "8230",
      "label": "Organization of conventions and trade shows"
    },
    {
      "value": "5590",
      "label": "Other accommodation n.e.c."
    },
    {
      "value": "6619",
      "label": "Other activities auxiliary to financial service activities, except insurance and pension funding"
    },
    {
      "value": "6629",
      "label": "Other activities auxiliary to insurance and pension funding"
    },
    {
      "value": "9329",
      "label": "Other amusement and recreation activities"
    },
    {
      "value": "9013",
      "label": "Other arts creation activities"
    },
    {
      "value": "8299",
      "label": "Other business support service activities n.e.c."
    },
    {
      "value": "8129",
      "label": "Other cleaning activities"
    },
    {
      "value": "6219",
      "label": "Other computer programming activities"
    },
    {
      "value": "4329",
      "label": "Other construction installation"
    },
    {
      "value": "6495",
      "label": "Other credit granting activities"
    },
    {
      "value": "8559",
      "label": "Other education n.e.c."
    },
    {
      "value": "8569",
      "label": "Other educational support activities"
    },
    {
      "value": "6499",
      "label": "Other financial service activities n.e.c., except insurance and pension funding activities"
    },
    {
      "value": "5629",
      "label": "Other food service activities"
    },
    {
      "value": "8699",
      "label": "Other human health activities n.e.c"
    },
    {
      "value": "6290",
      "label": "Other information technology and computer service activities"
    },
    {
      "value": "3290",
      "label": "Other manufacturing n.e.c."
    },
    {
      "value": "0899",
      "label": "Other mining and quarrying n.e.c."
    },
    {
      "value": "6419",
      "label": "Other monetary intermediation"
    },
    {
      "value": "4719",
      "label": "Other non-specialized retail sale"
    },
    {
      "value": "4922",
      "label": "Other passenger land transport"
    },
    {
      "value": "9690",
      "label": "Other personal service activities n.e.c."
    },
    {
      "value": "5819",
      "label": "Other publishing activities"
    },
    {
      "value": "6829",
      "label": "Other real estate activities on a fee or contract basis"
    },
    {
      "value": "8799",
      "label": "Other residential care activities n.e.c."
    },
    {
      "value": "5520",
      "label": "Other short term accommodation activities"
    },
    {
      "value": "8890",
      "label": "Other social work activities without accommodation"
    },
    {
      "value": "5829",
      "label": "Other software publishing"
    },
    {
      "value": "4390",
      "label": "Other specialized construction activities"
    },
    {
      "value": "9319",
      "label": "Other sports activities"
    },
    {
      "value": "5229",
      "label": "Other support activities for transportation"
    },
    {
      "value": "9039",
      "label": "Other support activities to arts creation and performing arts"
    },
    {
      "value": "6190",
      "label": "Other telecommunication activities"
    },
    {
      "value": "7990",
      "label": "Other travel related activities"
    },
    {
      "value": "8292",
      "label": "Packaging activities"
    },
    {
      "value": "5110",
      "label": "Passenger air transport"
    },
    {
      "value": "4911",
      "label": "Passenger rail transport, interurban"
    },
    {
      "value": "7491",
      "label": "Patent brokering and marketing service activities"
    },
    {
      "value": "6530",
      "label": "Pension funding"
    },
    {
      "value": "7420",
      "label": "Photographic activities"
    },
    {
      "value": "0130",
      "label": "Plant propagation"
    },
    {
      "value": "4322",
      "label": "Plumbing, heat and air-conditioning installation"
    },
    {
      "value": "0163",
      "label": "Post-harvest crop activities"
    },
    {
      "value": "8533",
      "label": "Post-secondary non-tertiary education"
    },
    {
      "value": "5310",
      "label": "Postal activities"
    },
    {
      "value": "8510",
      "label": "Pre-primary education"
    },
    {
      "value": "1311",
      "label": "Preparation and spinning of textile fibres"
    },
    {
      "value": "8520",
      "label": "Primary education"
    },
    {
      "value": "1811",
      "label": "Printing"
    },
    {
      "value": "1020",
      "label": "Processing and preserving of fish, crustaceans and molluscs"
    },
    {
      "value": "1030",
      "label": "Processing and preserving of fruit and vegetables"
    },
    {
      "value": "1010",
      "label": "Processing and preserving of meat"
    },
    {
      "value": "1076",
      "label": "Processing of coffee and tea"
    },
    {
      "value": "8423",
      "label": "Public order and safety activities"
    },
    {
      "value": "7330",
      "label": "Public relations activities"
    },
    {
      "value": "5811",
      "label": "Publishing of books"
    },
    {
      "value": "5813",
      "label": "Publishing of journals and periodicals"
    },
    {
      "value": "5812",
      "label": "Publishing of newspapers"
    },
    {
      "value": "5821",
      "label": "Publishing of video games"
    },
    {
      "value": "0810",
      "label": "Quarrying of stone, sand and clay"
    },
    {
      "value": "6010",
      "label": "Radio broadcasting and audio distribution activities"
    },
    {
      "value": "0143",
      "label": "Raising of camels and camelids"
    },
    {
      "value": "0141",
      "label": "Raising of cattle and buffaloes"
    },
    {
      "value": "0142",
      "label": "Raising of horses and other equines"
    },
    {
      "value": "0149",
      "label": "Raising of other animals"
    },
    {
      "value": "0146",
      "label": "Raising of poultry"
    },
    {
      "value": "0144",
      "label": "Raising of sheep and goats"
    },
    {
      "value": "0145",
      "label": "Raising of swine and pigs"
    },
    {
      "value": "6810",
      "label": "Real estate activities with own or leased property"
    },
    {
      "value": "8414",
      "label": "Regulation of and contribution to more efficient operation of businesses"
    },
    {
      "value": "8413",
      "label": "Regulation of the activities of providing environmental services"
    },
    {
      "value": "8412",
      "label": "Regulation of the activities of providing health care, education, cultural services and other social services, excluding social security and environment"
    },
    {
      "value": "6520",
      "label": "Reinsurance"
    },
    {
      "value": "3900",
      "label": "Remediation and other waste management service activities"
    },
    {
      "value": "7710",
      "label": "Rental and leasing of motor vehicles"
    },
    {
      "value": "7730",
      "label": "Rental and leasing of other machinery, equipment and tangible goods"
    },
    {
      "value": "7729",
      "label": "Rental and leasing of other personal and household goods"
    },
    {
      "value": "7721",
      "label": "Rental and leasing of recreational and sports goods"
    },
    {
      "value": "9510",
      "label": "Repair and maintenance of computers and communication equipment"
    },
    {
      "value": "9521",
      "label": "Repair and maintenance of consumer electronics"
    },
    {
      "value": "3314",
      "label": "Repair and maintenance of electrical equipment"
    },
    {
      "value": "3313",
      "label": "Repair and maintenance of electronic and optical equipment"
    },
    {
      "value": "3311",
      "label": "Repair and maintenance of fabricated metal products"
    },
    {
      "value": "9523",
      "label": "Repair and maintenance of footwear and leather goods"
    },
    {
      "value": "9524",
      "label": "Repair and maintenance of furniture and home furnishings"
    },
    {
      "value": "9522",
      "label": "Repair and maintenance of household appliances and home and garden equipment"
    },
    {
      "value": "3312",
      "label": "Repair and maintenance of machinery"
    },
    {
      "value": "9531",
      "label": "Repair and maintenance of motor vehicles"
    },
    {
      "value": "9532",
      "label": "Repair and maintenance of motorcycles"
    },
    {
      "value": "3319",
      "label": "Repair and maintenance of other equipment"
    },
    {
      "value": "9529",
      "label": "Repair and maintenance of other personal and household goods"
    },
    {
      "value": "3315",
      "label": "Repair and maintenance of transport equipment, except motor vehicles"
    },
    {
      "value": "1820",
      "label": "Reproduction of recorded media"
    },
    {
      "value": "7210",
      "label": "Research and experimental development on natural sciences and engineering"
    },
    {
      "value": "7220",
      "label": "Research and experimental development on social sciences and humanities"
    },
    {
      "value": "8730",
      "label": "Residential care activities for older persons or persons with physical disabilities"
    },
    {
      "value": "8720",
      "label": "Residential care activities for persons living with or having a diagnosis of a mental illness or substance abuse"
    },
    {
      "value": "8710",
      "label": "Residential nursing care activities"
    },
    {
      "value": "5610",
      "label": "Restaurants and mobile food service activities"
    },
    {
      "value": "4730",
      "label": "Retail sale of automotive fuel"
    },
    {
      "value": "4722",
      "label": "Retail sale of beverages"
    },
    {
      "value": "4761",
      "label": "Retail sale of books, newspapers, stationery and office supplies"
    },
    {
      "value": "4753",
      "label": "Retail sale of carpets, rugs, wall and floor coverings"
    },
    {
      "value": "4771",
      "label": "Retail sale of clothing, footwear and leather articles"
    },
    {
      "value": "4769",
      "label": "Retail sale of cultural and recreational goods n.e.c."
    },
    {
      "value": "4759",
      "label": "Retail sale of electrical household appliances, furniture, lighting equipment and other household articles"
    },
    {
      "value": "4721",
      "label": "Retail sale of food"
    },
    {
      "value": "4763",
      "label": "Retail sale of games and toys"
    },
    {
      "value": "4752",
      "label": "Retail sale of hardware, building materials, paints and glass"
    },
    {
      "value": "4740",
      "label": "Retail sale of information and communication equipment"
    },
    {
      "value": "4782",
      "label": "Retail sale of motor vehicle parts and accessories"
    },
    {
      "value": "4781",
      "label": "Retail sale of motor vehicles"
    },
    {
      "value": "4783",
      "label": "Retail sale of motorcycles, motorcycles parts and accessories"
    },
    {
      "value": "4773",
      "label": "Retail sale of other new goods n.e.c."
    },
    {
      "value": "4772",
      "label": "Retail sale of pharmaceutical and medical goods, cosmetic and toilet articles"
    },
    {
      "value": "4774",
      "label": "Retail sale of second-hand goods"
    },
    {
      "value": "4762",
      "label": "Retail sale of sporting equipment"
    },
    {
      "value": "4751",
      "label": "Retail sale of textiles"
    },
    {
      "value": "4723",
      "label": "Retail sale of tobacco products"
    },
    {
      "value": "6621",
      "label": "Risk and damage evaluation"
    },
    {
      "value": "1610",
      "label": "Sawmilling and planing of wood"
    },
    {
      "value": "5012",
      "label": "Sea and coastal freight water transport"
    },
    {
      "value": "5011",
      "label": "Sea and coastal passenger water transport"
    },
    {
      "value": "6494",
      "label": "Securitisation activities"
    },
    {
      "value": "8019",
      "label": "Security activities n.e.c."
    },
    {
      "value": "6612",
      "label": "Security and commodity contracts brokerage"
    },
    {
      "value": "0164",
      "label": "Seed processing for propagation"
    },
    {
      "value": "5223",
      "label": "Service activities incidental to air transportation"
    },
    {
      "value": "5221",
      "label": "Service activities incidental to land transportation"
    },
    {
      "value": "5222",
      "label": "Service activities incidental to water transportation"
    },
    {
      "value": "1812",
      "label": "Service activities related to printing"
    },
    {
      "value": "3700",
      "label": "Sewerage"
    },
    {
      "value": "0210",
      "label": "Silviculture and other forestry activities"
    },
    {
      "value": "4312",
      "label": "Site preparation"
    },
    {
      "value": "6039",
      "label": "Social network sites and other content distribution activities"
    },
    {
      "value": "8810",
      "label": "Social work activities without accommodation for older persons or persons with disabilities"
    },
    {
      "value": "5920",
      "label": "Sound recording and music publishing activities"
    },
    {
      "value": "7410",
      "label": "Specialized design activities"
    },
    {
      "value": "8551",
      "label": "Sports and recreation education"
    },
    {
      "value": "3530",
      "label": "Steam and air conditioning supply"
    },
    {
      "value": "0162",
      "label": "Support activities for animal production"
    },
    {
      "value": "0161",
      "label": "Support activities for crop production"
    },
    {
      "value": "0330",
      "label": "Support activities for fishing and aquaculture"
    },
    {
      "value": "0990",
      "label": "Support activities for other mining and quarrying"
    },
    {
      "value": "0910",
      "label": "Support activities for petroleum and natural gas extraction"
    },
    {
      "value": "0240",
      "label": "Support services to forestry"
    },
    {
      "value": "1511",
      "label": "Tanning and dressing of leather; dressing and dyeing of fur"
    },
    {
      "value": "7120",
      "label": "Technical testing and analysis"
    },
    {
      "value": "6120",
      "label": "Telecommunication reselling activities and intermediation service activities for telecommunication"
    },
    {
      "value": "6020",
      "label": "Television programming, broadcasting and video distribution activities"
    },
    {
      "value": "7820",
      "label": "Temporary employment agency activities and other human resource provisions"
    },
    {
      "value": "8540",
      "label": "Tertiary education"
    },
    {
      "value": "7912",
      "label": "Tour operator activities"
    },
    {
      "value": "7430",
      "label": "Translation and interpretation activities"
    },
    {
      "value": "4930",
      "label": "Transport via pipeline"
    },
    {
      "value": "7911",
      "label": "Travel agency activities"
    },
    {
      "value": "2592",
      "label": "Treatment and coating of metals; machining"
    },
    {
      "value": "3822",
      "label": "Treatment and disposal of hazardous waste"
    },
    {
      "value": "3821",
      "label": "Treatment and disposal of non-hazardous waste"
    },
    {
      "value": "9810",
      "label": "Undifferentiated goods-producing activities of private households for own use"
    },
    {
      "value": "9820",
      "label": "Undifferentiated service-producing activities of private households for own use"
    },
    {
      "value": "4921",
      "label": "Urban and suburban passenger land transport"
    },
    {
      "value": "7500",
      "label": "Veterinary activities"
    },
    {
      "value": "9012",
      "label": "Visual arts creation activities"
    },
    {
      "value": "8532",
      "label": "Vocational secondary education"
    },
    {
      "value": "5210",
      "label": "Warehousing and storage"
    },
    {
      "value": "9610",
      "label": "Washing and cleaning of textile and fur products"
    },
    {
      "value": "3600",
      "label": "Water collection, treatment and supply"
    },
    {
      "value": "1312",
      "label": "Weaving of textiles"
    },
    {
      "value": "6390",
      "label": "Web search portals activities and other information service activities"
    },
    {
      "value": "4653",
      "label": "Wholesale of agricultural machinery, equipment and supplies"
    },
    {
      "value": "4620",
      "label": "Wholesale of agricultural raw materials and live animals"
    },
    {
      "value": "4679",
      "label": "Wholesale of chemicals, waste and scrap and other products n.e.c."
    },
    {
      "value": "4651",
      "label": "Wholesale of computers, computer peripheral equipment and software"
    },
    {
      "value": "4673",
      "label": "Wholesale of construction materials, hardware, plumbing and heating equipment and supplies"
    },
    {
      "value": "4652",
      "label": "Wholesale of electronic and telecommunications equipment and parts"
    },
    {
      "value": "4630",
      "label": "Wholesale of food, beverages and tobacco"
    },
    {
      "value": "4642",
      "label": "Wholesale of household, office and shop furniture, carpets and lighting equipment"
    },
    {
      "value": "4672",
      "label": "Wholesale of metals and metal ores"
    },
    {
      "value": "4662",
      "label": "Wholesale of motor vehicle parts and accessories"
    },
    {
      "value": "4661",
      "label": "Wholesale of motor vehicles"
    },
    {
      "value": "4663",
      "label": "Wholesale of motorcycles, motorcycle parts and accessories"
    },
    {
      "value": "4649",
      "label": "Wholesale of other household goods"
    },
    {
      "value": "4659",
      "label": "Wholesale of other machinery and equipment"
    },
    {
      "value": "4671",
      "label": "Wholesale of solid, liquid and gaseous fuels and related products"
    },
    {
      "value": "4641",
      "label": "Wholesale of textiles, clothing and footwear"
    },
    {
      "value": "4610",
      "label": "Wholesale on a fee or contract basis"
    },
    {
      "value": "6110",
      "label": "Wired, wireless, and satellite telecommunication activities"
    }
  ]
}
